export default __webpack_public_path__ + "static/media/icon_2.aad412a7.png";